import api, { URLS } from "@/services/api.js";

const BASE_URL = URLS.API_CONSULTA_ENTIDADE;

export const ENTIDADES = {
	ATIVIDADE_ECONOMICA: "ATIVIDADE_ECONOMICA",
	CONDICAO_ADMINISTRADOR: "CONDICAO_ADMINISTRADOR",
	CONDICAO_SOCIO: "CONDICAO_SOCIO",
	ESTADO_CIVIL: "ESTADO_CIVIL",
	FORMA_ATUACAO: "FORMA_ATUACAO",
	MUNICIPIO: "MUNICIPIO",
	NACIONALIDADE: "NACIONALIDADE",
	UF: "UF",
	REGIAO_ADMINISTRATIVA: "REGIAO_ADMINISTRATIVA",
	PAIS: "PAIS",
	REGIME_BENS: "REGIME_BENS",
	TIPO_COMPLEMENTO: "TIPO_COMPLEMENTO",
	TIPO_REPRESENTANTE_LEGAL: "TIPO_REPRESENTANTE_LEGAL",
	TIPO_UNIDADE: "TIPO_UNIDADE",
	TIPO_LOGRADOURO: "TIPO_LOGRADOURO",
	SITUACAO_PROCESSO_BU: "SITUACAO_PROCESSO_BU",
	ESCOLARIDADE_FGTAS: "ESCOLARIDADE_FGTAS",
	TIPO_HABILITACAO_FGTAS: "TIPO_HABILITACAO_FGTAS",
	TIPO_BENEFICIO_FGTAS: "TIPO_BENEFICIO_FGTAS",
	MOTIVO_CONTRATACAO_FGTAS: "MOTIVO_CONTRATACAO_FGTAS",
	CBO_FGTAS: "CBO_FGTAS",
	EXPERIENCIA_FGTAS: "EXPERIENCIA_FGTAS",
	SETOR_FGTAS: "SETOR_FGTAS",
	SERVICO_FGTAS: "SERVICO_FGTAS",
};

export const listarEntidade = (entidade) => api.request({
	method: "get",
	baseURL: BASE_URL,
	url: `/listar/${entidade}`,
});

export const listarEntidadeFiltradas = (entidade, campo, valor) => api.request({
	method: "get",
	baseURL: BASE_URL,
	url: `/listar-com-filtro/${entidade}/${campo}/${valor}`,
});

export const listarUfs = () => listarEntidade(ENTIDADES.UF);

export const listarEscolaridade = () => listarEntidade(ENTIDADES.ESCOLARIDADE_FGTAS);

export const listarHabilitacoes = () => listarEntidade(ENTIDADES.TIPO_HABILITACAO_FGTAS);

export const listarBeneficios = () => listarEntidade(ENTIDADES.TIPO_BENEFICIO_FGTAS);

export const listarCBO = () => listarEntidade(ENTIDADES.CBO_FGTAS);

export const listarExperiencias = () => listarEntidade(ENTIDADES.EXPERIENCIA_FGTAS);

export const listarMotivoContratacao = () => listarEntidade(ENTIDADES.MOTIVO_CONTRATACAO_FGTAS);

export const listarSetores = () => listarEntidade(ENTIDADES.SETOR_FGTAS);

export const listarServicos = () => listarEntidade(ENTIDADES.SERVICO_FGTAS);

export const listarMunicipios = (siglaUF) => listarEntidadeFiltradas(ENTIDADES.MUNICIPIO, "uf.siglaUf", siglaUF);

export const listarTipoLogradouro = () => listarEntidade(ENTIDADES.TIPO_LOGRADOURO);

export const listarFormasAtuacao = () => listarEntidade(ENTIDADES.FORMA_ATUACAO);

export const listarTipoComplemento = () => listarEntidade(ENTIDADES.TIPO_COMPLEMENTO);

export const listarPaises = () => listarEntidade(ENTIDADES.PAIS);

export const listarAtividadesEconomicas = () => listarEntidade(ENTIDADES.ATIVIDADE_ECONOMICA);

export const obterUfAtual = () => listarEntidadeFiltradas(ENTIDADES.UF, "siglaUf", import.meta.env.VITE_UF);
